import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { ApiRequestError } from "@/api/errors"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatSeconds(total: number) {
  const minutes = Math.floor(total / 60)
  const seconds = total % 60
  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
}

export function saveFileToDisk(file: File, filename: string) {
  const a = document.createElement("a")
  const url = window.URL.createObjectURL(file)
  a.href = url
  a.download = filename
  a.click()
  window.URL.revokeObjectURL(url)
  a.remove()
}

export const parseError = (err: Error) => {
  if (err instanceof ApiRequestError) {
    return err.message
  }

  if (err instanceof Error && "issues" in err) {
    console.error(err)
    return "Error de validación"
  }

  return err.message
}
